
import { Component, MixedVue } from "@/vue";
import { mixins } from "vue-class-component";
import { gettersInstance, isMobile, parseQueryBool, releaseHijack } from "../lib/util";

const StoreGetters = gettersInstance(["user"]);

@Component({
  name: "HijackNotification",
})
export default class HijackNotification extends mixins(MixedVue, StoreGetters) {
  showBanner = true;
  clickTimeout: number;
  clickCount = 0;

  created() {
    this.showBanner = parseQueryBool(window.localStorage.getItem("showBanner"), true);
    this.initTooltips();
    document.addEventListener("click", this.countClick), true;
  }

  destroyed() {
    document.removeEventListener("click", this.countClick, true);
  }

  async release() {
    releaseHijack();
  }

  toggleBanner() {
    this.showBanner = !this.showBanner;
    window.localStorage.setItem("showBanner", this.showBanner.toString());
    this.initTooltips();
  }

  countClick() {
    clearTimeout(this.clickTimeout);
    this.clickCount++;
    if (this.clickCount === 5) {
      this.clickCount = 0;
      if (isMobile() && confirm("Stop impersonating?")) {
        this.release();
      }
      return;
    }
    this.clickTimeout = window.setTimeout(() => {
      this.clickCount = 0;
    }, 300);
  }
}
